// 绑定银行卡
const wxRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `withdrawal/wx/index${i + 1}`,
  name: `withdrawal/wx/Index${i + 1}`,
  component: () => import(`@/views/shopping/withdrawal/wx/index${i + 1}.vue`)
}))
const zfbRoutes = Array.from({ length:10 }, (_, i) => ({
  path: `withdrawal/zfb/index${i + 1}`,
  name: `withdrawal/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/withdrawal/zfb/index${i + 1}.vue`)
}))

import withdrawalIndex from '@/views/shopping/withdrawal/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'withdrawal/index',
        name: 'withdrawalIndex',
        component: withdrawalIndex
      },
    // 绑定银行卡，开始
    ...wxRoutes,
    ...zfbRoutes,

  ],
};
